<div class="error-image">
  <div class="dropdown float-end custom-layout">
    <!-- <div class="switch-icon nav-link icon"  (click)="toggleSwitcher()">
        <i class="fe fe-settings fa-spin text_primary"></i>
    </div> -->
  </div>
  <router-outlet></router-outlet>
</div>
